export const LOAD_REQUESTED = "ACTION_BUTTON_ARRAY_FIELD_TEMPLATE/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ACTION_BUTTON_ARRAY_FIELD_TEMPLATE/LOAD_SUCCESS";
export const LOAD_FAIL = "ACTION_BUTTON_ARRAY_FIELD_TEMPLATE/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadActionButtonArrayFieldTemplate = data => ({ type: LOAD_REQUESTED, data });
export const successLoadActionButtonArrayFieldTemplate = data => ({ type: LOAD_SUCCESS, data });
export const failLoadActionButtonArrayFieldTemplate = data => ({ type: LOAD_FAIL, data });
